type GuidedStepLocale = "ar" | "en";

export const detectGuidedStepLocale = (value: string): GuidedStepLocale =>
  /[\u0600-\u06ff]/.test(value) ? "ar" : "en";

export const getGuidedPhaseLabel = (
  phase: "i_do" | "we_do" | "you_do" | "summary",
  locale: GuidedStepLocale,
) => {
  if (locale === "ar") {
    switch (phase) {
      case "i_do":
        return "أنا أشرح";
      case "we_do":
        return "نحل معًا";
      case "you_do":
        return "جرّب بنفسك";
      case "summary":
        return "الخلاصة";
    }
  }

  switch (phase) {
    case "i_do":
      return "I do";
    case "we_do":
      return "We do";
    case "you_do":
      return "You do";
    case "summary":
      return "Summary";
  }
};

export const getGuidedUiCopy = (locale: GuidedStepLocale) =>
  locale === "ar"
    ? {
        step: "الخطوة",
        submit: "تحقق من الإجابة",
        tryAgain: "حاول مرة أخرى",
        next: "الخطوة التالية",
        skip: "تخط هذه الخطوة",
        skipConfirm: "هل تريد تخطي هذه الخطوة؟",
        trueLabel: "صح",
        falseLabel: "خطأ",
        answerLabel: "إجابتك",
        hintLabel: "تلميح",
        revealLabel: "الإجابة",
        helper: "خذ خطوة واحدة الآن ثم نكمل من هناك.",
        correctLabel: "إجابة صحيحة",
        hintStateLabel: "تلميح قبل المحاولة التالية",
        revealStateLabel: "كشف الإجابة ثم نكمل",
      }
    : {
        step: "Step",
        submit: "Check answer",
        tryAgain: "Try again",
        next: "Next step",
        skip: "Skip this step",
        skipConfirm: "Skip this step?",
        trueLabel: "True",
        falseLabel: "False",
        answerLabel: "Your answer",
        hintLabel: "Hint",
        revealLabel: "Answer",
        helper: "Take one clear step here, then keep moving.",
        correctLabel: "Correct",
        hintStateLabel: "Hint before the next try",
        revealStateLabel: "Answer revealed, then move on",
      };
